import { c as _c } from "react/compiler-runtime";
import { NoAnnotationsDuoIcon, Text, XMarkCircleFillIcon } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { getSvgColoredIconCss } from "@utils/ui-utils";
/** Empty state of the summary, with the same look as the empty annotations table but sized to fit the chart */
export function MarkupsSummaryEmpty(t0) {
  const $ = _c(16);
  const {
    message,
    isError: t1
  } = t0;
  const isError = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      textAlign: "center",
      gap: 2
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "7.5rem",
      height: "7.5rem",
      borderRadius: "50%",
      backgroundColor: "surfaces.secondary",
      justifyContent: "center",
      alignItems: "center"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isError) {
    t4 = <Stack sx={t3}>{isError ? <XMarkCircleFillIcon sx={{
        ...getSvgColoredIconCss(PALETTE_VARS.error.main),
        width: "2.5rem",
        height: "2.5rem"
      }} /> : <NoAnnotationsDuoIcon sx={{
        width: "2.5rem",
        height: "2.5rem"
      }} />}</Stack>;
    $[2] = isError;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      gap: 0.5
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isError ? "Error" : "No annotations";
  let t7;
  if ($[5] !== t6) {
    t7 = <Text variant="heading20">{t6}</Text>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      color: "text.secondary"
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== message) {
    t9 = <Text variant="bodyM" sx={t8}>{message}</Text>;
    $[8] = message;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7 || $[11] !== t9) {
    t10 = <Stack sx={t5}>{t7}{t9}</Stack>;
    $[10] = t7;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t4) {
    t11 = <Stack sx={t2}>{t4}{t10}</Stack>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}